import { Injectable } from '@angular/core';

import { NavigationProvider } from '@nrwl/navigation-abstract';

@Injectable({
  providedIn: 'root'
})
export class WizardNavigatorService {

  constructor(
    private readonly navigator: NavigationProvider
  ) { }

  navigateToWizard(wizardId: any, defaultParams = {}): void { //eslint-disable-line
    this.navigator.navigateToWizard([wizardId], {
      queryParams: {
        defaultParams: JSON.stringify(defaultParams)
      }
    });
  }
}
